<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        :height="height" :class="classes" class="fill-current">
        <path d="M 3 2 C 2.448 2 2 2.448 2 3 L 2 13 C 2 13.552 2.448 14 3 14 L 21 14 C 21.552 14 22 13.552 22 13 L 22 3 C 22 2.448 21.552 2 21 2 L 3 2 z M 4.9121094 4 L 19.087891 4 A 1.5 1.5 0 0 0 20 4.9121094 L 20 11.087891 A 1.5 1.5 0 0 0 19.087891 12 L 4.9121094 12 A 1.5 1.5 0 0 0 4 11.087891 L 4 4.9121094 A 1.5 1.5 0 0 0 4.9121094 4 z M 12 5 A 3 3 0 0 0 9 8 A 3 3 0 0 0 12 11 A 3 3 0 0 0 15 8 A 3 3 0 0 0 12 5 z M 7 7 C 6.448 7 6 7.447 6 8 C 6 8.553 6.448 9 7 9 C 7.552 9 8 8.553 8 8 C 8 7.447 7.552 7 7 7 z M 17 7 C 16.448 7 16 7.447 16 8 C 16 8.553 16.448 9 17 9 C 17.552 9 18 8.553 18 8 C 18 7.447 17.552 7 17 7 z M 11 16 L 11 18 L 7.9511719 18 L 11.951172 22 L 15.951172 18 L 13 18 L 13 16 L 11 16 z"/>
    </svg>
</template>

<script>
export default {
    props: [ 'height', 'classes' ]
}
</script>